export default __webpack_public_path__ + "static/media/ic_link_24.9f1a874f.svg";